<template>
  <div class="hdrGen">
    <!-- Auslöser im Header: läuft etwas → Ladekreis + Anzahl; alles fertig → „fertig/gestartet", bis der Dialog geöffnet wird -->
    <button type="button" class="hdrGen__trigger" :class="{ open, busy: running, fresh: !running && doneTotal, failed: !running && doneTotal && doneOk < doneTotal }" :title="title" @click="toggle">
      <v-progress-circular v-if="running" indeterminate size="16" width="2" color="#7b5cd6" />
      <v-icon v-else small>{{ doneTotal ? (doneOk < doneTotal ? "mdi-alert-circle-outline" : "mdi-check-circle-outline") : "mdi-auto-fix" }}</v-icon>
      <span>Generieren</span>
      <span v-if="running" class="hdrGen__badge">{{ running }}</span>
      <span v-else-if="doneTotal" class="hdrGen__badge hdrGen__badge--done">{{ doneOk }}/{{ doneTotal }}</span>
    </button>

    <!-- Inhalt bleibt nach dem ersten Öffnen erhalten (Fotos, Stil, Ergebnisse), Läufe laufen im Store weiter -->
    <v-dialog v-model="open" width="1480" max-width="97vw" content-class="hdrGen__dialog" :retain-focus="false">
      <GenerateView v-if="opened" embedded @close="open = false" />
    </v-dialog>
  </div>
</template>

<script>
import GenerateView from "@/views/GenerateView.vue";
import { ackActivity, generateActivity } from "@/generateRuns";

export default {
  name: "HeaderGenerate",
  components: { GenerateView },
  data: () => ({ open: false, opened: false }),
  computed: {
    /** laufende Generierungen + Upscale-Jobs */
    running() {
      return generateActivity.items.filter((i) => i.status === "running").length;
    },
    /** seit dem letzten Öffnen fertig geworden */
    finishedUnseen() {
      return generateActivity.items.filter((i) => i.status !== "running" && i.finishedAt > generateActivity.ackAt);
    },
    doneTotal() {
      return this.finishedUnseen.length;
    },
    doneOk() {
      return this.finishedUnseen.filter((i) => i.status === "done").length;
    },
    title() {
      if (this.running) return `${this.running} Lauf${this.running === 1 ? "" : "e"} (Generierung/Upscale) aktiv`;
      if (this.doneTotal) return `${this.doneOk} von ${this.doneTotal} fertig${this.doneOk < this.doneTotal ? ", Rest fehlgeschlagen" : ""} — Dialog öffnen zum Ansehen`;
      return "Generieren / Upscale";
    },
  },
  watch: {
    // Was bei offenem Dialog fertig wurde, ist gesehen → beim Schließen ebenfalls quittieren
    open(v) {
      if (!v) ackActivity();
    },
  },
  methods: {
    toggle() {
      this.opened = true;
      this.open = !this.open;
      if (this.open) ackActivity();
    },
  },
};
</script>

<style lang="scss" scoped>
.hdrGen {
  position: relative;
  margin-right: 12px;

  &__trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    padding: 0 14px;
    border-radius: 999px;
    background: #f4f3f7;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.65);
    transition: background 0.15s, box-shadow 0.15s;

    &:hover,
    &.open,
    &.busy {
      background: #edeafa;
      color: #6a4fc4;
    }
    &.fresh {
      background: #e4f5eb;
      color: #2e7d32;
      .v-icon { color: #2e7d32 !important; }
    }
    &.failed {
      background: #fbe9e7;
      color: #b23a31;
      .v-icon { color: #b23a31 !important; }
    }
  }
  &__badge {
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 999px;
    background: #7b5cd6;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;

    .fresh & { background: #2e7d32; }
    .failed & { background: #b23a31; }
  }
}
</style>

<style lang="scss">
/* Dialog-Hülle (nicht scoped: content-class liegt außerhalb der Komponente) */
.hdrGen__dialog {
  border-radius: 18px !important;
  background: #f4f5f8;
  max-height: 92vh !important;
  overflow-y: auto;
}
</style>
